import { serviceName } from '../resources/serviceConstants';
import { FILE_UPLOAD_ENDPOINT } from '../resources/endPoint';

export const fileUploadApi = (schedulerType, fileCategory, runBy, file) => {
  const url = FILE_UPLOAD_ENDPOINT;

  const formData = new FormData();
  formData.append('schedulerType', schedulerType);
  formData.append('fileCategory', fileCategory);
  formData.append('runBy', runBy);
  formData.append('file', file);


  return {
    url: url,
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data',
    },
    authRequired: true,
    csrfToken: true,
    payload: formData,
    service: serviceName.INTEGRATION_MS,
    timeout: 300000,
  };
};
